import React, { useMemo } from 'react';
import FlipMove from "react-flip-move";
import PositionSkillsForm from "../components/PositionSkillsForm";
import EmptyBanner from "../../../components/EmptyBanner";
import UserDiscipline from "../../../models/UserDiscipline";
import { useOutletContext } from "react-router-dom";
import { usePositionForm } from "../../../providers/PositionFormProvider";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';

const FilteredSkills = ({ available = [], canRemove = true, ...props }) => {
    const { formModel: position } = usePositionForm();

    const selectedIds = useMemo(() => TB.map(position.skills || [], 'id'), [position?.skills]);

    const allSkills = useMemo(() => {
        let skills = TB.map(available || [], skill => {
            if (selectedIds.includes(parseInt(skill.id))) {
                return TB.find(position.skills, ['id', parseInt(skill.id)]);
            }

            return TB.pick(skill, ['id', 'name', 'type', 'type_name']);
        })

        return TB.orderBy(skills || [], [
            skill => selectedIds.includes(skill?.id) ? selectedIds.indexOf(skill.id) : 1000,
            skill => selectedIds.includes(skill?.id),
        ], ['asc', 'asc'])
    }, [
        selectedIds,
        available
    ]);

    return (
        <div className="flex flex-col items-stretch relative">
            {allSkills.length > 0 && (
                <div className="discipline-skills-container skill-importance-container relative gap-3">
                    <FlipMove typeName={null} maintainContainerHeight={true}>
                        {allSkills.map((skill, index) => {
                            return (
                                <div key={skill.id}>
                                    <NEWSkillFormButton
                                        valuePropName={'importance'}
                                        disabled={props.isDisabled}
                                        scoringOptions={laravel.importance_levels}
                                        skill={skill}
                                        onChange={model => props.onChange(model)}
                                        className="min-w-[115px]"
                                    />
                                </div>
                            )
                        })}
                    </FlipMove>
                </div>
            )}
        </div>
    )
}

const PositionSkills = props => {

    const { formModel: position } = usePositionForm();
    const {
        isDisabled, goBack, onSubmit, onChange
    } = useOutletContext();

    const selectSkill = async (skill) => {

        let skills = [...(position.skills || [])];

        if (TB.isDefined(skill.importance)) {
            if (TB.find(skills, ['id', skill.id])) {
                skills = TB.map(skills, model => {
                    if (model.id === skill.id) {
                        return { ...skill };
                    }
                    return model;
                });
            } else {
                skills.push(skill);
            }

        } else {
            skills = TB.xorBy(skills, [skill], 'id');
        }

        console.log('skills on selectSkill', skills)

        return onChange({ skills })
    }

    const templateSkills = useMemo(() => {
        let skills = TB.flatten(TB.map(position.templates || [], 'skills'));
        skills = TB.filter(skills, TB.isObject)
        return TB.uniqBy(skills, 'id')
    }, [position.templates]);

    const allDisciplineSkills = useMemo(() => {
        let skills = TB.flatten(
            TB.map(position.templates || [], template => UserDiscipline.skillsForDisciplines(TB.map(template.disciplines || [], 'id')))
        );
        skills = TB.filter(skills, TB.isObject)

        return TB.uniqBy(skills, 'id') || []
    }, [position.templates]);

    const customSkills = useMemo(() => {
        let allSkills = TB.uniqBy([...templateSkills, ...allDisciplineSkills], 'id')
        return TB.filter(position.skills, skill => !TB.find(allSkills, ['id', skill.id]))
    }, [position.skills]);

    return (
        <div className="flex flex-col gap-[32px]">
            <div className="flex flex-col justify-start items-start self-stretch relative gap-4">
                <p className="self-stretch text-lg font-semibold text-left text-black">
                    Skills Chosen
                </p>
                {position.templates?.length > 0 && (
                    <p className="self-stretch text-xs text-[#334d6e]">
                        These are the default skills for your {TB.pluralize('role', position.templates.length)}, but you can always add more.
                    </p>
                )}
                {templateSkills?.length > 0 && (
                    <FilteredSkills
                        available={templateSkills}
                        onChange={skill => selectSkill(skill)}
                        // canRemove={false}
                        isDisabled={isDisabled} />
                )}
            </div>



            {position.templates?.length > 0 && (
                <div className="flex flex-col justify-start items-stretch self-stretch">
                    <p className="self-stretch text-xs text-[#334d6e] mb-2">
                        Common skills for your {TB.pluralize('role', position.templates.length)}.
                    </p>

                    {TB.map(position.templates, template => {
                        if (!template?.disciplines?.length) return null;

                        let disciplineSkills = UserDiscipline.skillsForDisciplines(TB.map(template.disciplines, 'id'));

                        disciplineSkills = TB.filter(disciplineSkills, skill => !TB.find(template.skills, ['id', skill.id]))
                        return (
                            <div key={`template-common-${template.id}`}
                                className="flex flex-col justify-center items-stretch gap-6 px-8 py-6 bg-white border border-[#eee]">
                                <p className="self-stretch flex-grow text-lg font-semibold text-left text-black">
                                    {template.name}
                                </p>
                                {disciplineSkills.length > 0 ? (
                                    <FilteredSkills
                                        available={disciplineSkills}
                                        onChange={skill => selectSkill(skill)}
                                        isDisabled={isDisabled} />
                                ) : (
                                    <EmptyBanner
                                        message="All of the top skills for this role have been selected." />
                                )}
                            </div>

                        )
                    })}
                </div>
            )}
            <div className="flex flex-col justify-start items-stretch self-stretch gap-[14px]">
                <p className="self-stretch text-xs text-[#334d6e]">
                    Didn't find what you're looking for? Search below to find other skills.
                </p>
                {customSkills?.length > 0 && (
                    <FilteredSkills
                        available={customSkills}
                        onChange={skill => selectSkill(skill)}
                        isDisabled={isDisabled} />
                )}

                <div className="skill-search-form">
                    <PositionSkillsForm
                        position={position}
                        disabled={isDisabled}
                        onUpdate={skills => onChange({ skills })}
                    />
                </div>
            </div>
        </div>
    );
};

PositionSkills.propTypes = {};

export default PositionSkills;